<div class="flex flex-col gap-2">
    <!----------------------------------------------------------------------------->
    <!-- Invoice Data -->
    <app-drop-down-section #invoiceDataDropdown title="{{ 'admin.invoice_data' | transloco }}"
        titleIcon="assets/icons/admin/file-black.svg" [sectionId]="'invoice-data'" [enableFloatingActiong]="true">
        <!-- Actions-->
        <app-edit-cancel-button header-actions [isEditing]="isEditingInvoiceData" [isSaving]="savingInvoice"
            (edit)="editInvoiceData()" (cancel)="cancelEditInvoiceData()"
            (save)="saveEditInvoiceData()"></app-edit-cancel-button>

        <!-- Body -->
        <table class="table w-full">
            <!-- Header -->
            <thead class="bg-neutral-100 text-neutral-700 uppercase">
                <tr class="max-h-[50px]">
                    <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.description' |
                        transloco
                        }}</th>
                    <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.extraction' |
                        transloco
                        }}</th>
                </tr>
            </thead>
            <!-- Content -->
            <tbody>
                <!-- For Period -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.period' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(forPeriodDate, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-date-input inputId="forPeriod"
                                placeholder="{{ 'invoice.placeholders.period' | transloco }}" autoMarginTop="mt-0"
                                [showOnlyValueWhenDisabled]="true" [(dateValue)]="forPeriodDate"
                                [errorMessage]="forPeriodInputError" dateFormat="mm/yy" boxHeight="h-[40px]"
                                [isDisabled]="!isEditingInvoiceData">
                            </app-custom-date-input>
                        </div>

                        @if(!isEditingInvoiceData && checkMandatoryVariableEmptyStatus(forPeriodDate, true) ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Invoice number -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.number' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkVariableEmptyStatus(invoiceNumberInput, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'invoiceNumber'" autoMarginTop="mt-0"
                                [inputType]="'text'" [(inputValue)]="invoiceNumberInput"
                                [errorMessage]="invoiceNumberInputError"
                                placeholder="{{ 'invoice.placeholders.number' | transloco }}">
                            </app-labeled-input>
                        </div>

                        @if(!isEditingInvoiceData && checkMandatoryVariableEmptyStatus(invoiceNumberInput, true) ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Invoice amount actual -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.amount_actual' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(invoiceAmountActualInput, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'invoiceAmountActual'"
                                autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="invoiceAmountActualInput"
                                [errorMessage]="invoiceAmountActualInputError"
                                [warningMessage]="invoiceAmountActualInputWarning"
                                placeholder="{{ 'invoice.placeholders.amount' | transloco }}"
                                (inputValueLength)="onFieldChange({ value: $event, fieldName: 'invoiceAmountActual' })">
                            </app-custom-number-input>
                        </div>

                        @if(!isEditingInvoiceData && checkMandatoryVariableEmptyStatus(invoiceAmountActualInput, true)
                        ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Invoice amount gross -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.amount_gross' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkVariableEmptyStatus(invoiceAmountGrossInput, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'invoiceAmountGross'"
                                autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="invoiceAmountGrossInput"
                                [errorMessage]="invoiceAmountGrossInputError"
                                placeholder="{{ 'invoice.placeholders.amount' | transloco }}">
                            </app-custom-number-input>
                        </div>

                        @if(!isEditingInvoiceData && checkMandatoryVariableEmptyStatus(invoiceAmountGrossInput, true) ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Invoice total discount amount -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.total_discount_amount' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkVariableEmptyStatus(totalDiscountInput, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'totalDiscount'" autoMarginTop="mt-0"
                                [inputType]="'number'" [(inputValue)]="totalDiscountInput"
                                [errorMessage]="totalDiscountInputError">
                            </app-custom-number-input>
                        </div>

                        @if(!isEditingInvoiceData && checkMandatoryVariableEmptyStatus(totalDiscountInput, true) ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Invoice nontaxable amount -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.nontaxable_amount' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkVariableEmptyStatus(nontaxableAmountInput, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'nontaxableAmount'" autoMarginTop="mt-0"
                                [inputType]="'number'" [(inputValue)]="nontaxableAmountInput"
                                [errorMessage]="nontaxableAmountInputError">
                            </app-custom-number-input>
                        </div>

                        @if(!isEditingInvoiceData && checkMandatoryVariableEmptyStatus(nontaxableAmountInput, true) ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>
            </tbody>
        </table>

    </app-drop-down-section>

    <!----------------------------------------------------------------------------->
    <!-- PODs -->
    <app-drop-down-section #podSection (openedChange)="onPodSectionOpenedChange(i, $event)"
        *ngFor="let pod of invoice?.pods; let i = index"
        title="{{ 'invoice.sections.pod_number' | transloco }} {{ i + 1}}"
        titleIcon="assets/icons/admin/power-black.svg" [sectionId]="'pod-' + i" [enableFloatingActiong]="true">

        <!-- Actions-->
        <app-edit-cancel-button header-actions [isEditing]="isEditingInvoiceData" [isSaving]="savingInvoice"
            (edit)="editInvoiceData()" (cancel)="cancelEditInvoiceData()"
            (save)="saveEditInvoiceData()"></app-edit-cancel-button>

        <!-- Body -->
        <table class="table w-full">
            <!-- Header -->
            <thead class="bg-neutral-100 text-neutral-700 uppercase">
                <tr class="max-h-[50px]">
                    <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.description' |
                        transloco
                        }}</th>
                    <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.extraction' |
                        transloco
                        }}</th>
                </tr>
            </thead>
            <!-- Content -->
            <tbody>
                <!-- For Period -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.period' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(forPeriodDate, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-date-input inputId="forPeriod"
                                placeholder="{{ 'invoice.placeholders.period' | transloco }}" autoMarginTop="mt-0"
                                [showOnlyValueWhenDisabled]="true" [(dateValue)]="forPeriodDate"
                                [errorMessage]="forPeriodInputError" dateFormat="mm/yy" boxHeight="h-[40px]"
                                [isDisabled]="!isEditingInvoiceData">
                            </app-custom-date-input>
                        </div>

                        @if(!isEditingInvoiceData && checkMandatoryVariableEmptyStatus(forPeriodDate, true)
                        ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Electricity POD ID -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'shared.labels.electricity.pod_id' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkVariableEmptyStatus(editedPods[i].pod_id, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'pod_id' + i" autoMarginTop="mt-0"
                                [(inputValue)]="editedPods[i].pod_id"
                                placeholder="{{ 'shared.placeholders.electricity.pod_id' | transloco }}">
                            </app-labeled-input>
                        </div>
                    </td>
                </tr>

                <!-- Invoice contract type -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.contract_type' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(editedPods[i].selectedContractTypeDropdown, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-dropdown [options]="contractTypeDropdownOptions"
                                [showOnlyValueWhenDisabled]="true"
                                [(selectedOption)]="editedPods[i].selectedContractTypeDropdown"
                                (selectedOptionChange)="onContractTypeChange(i)" [disabled]="saveClicked"
                                [warningMessage]="contractTypeDropdownWarning[i]" [disabled]="!isEditingInvoiceData"
                                boxHeight="h-[40px]" autoMarginTop="mt-0">
                            </app-custom-dropdown>
                        </div>

                        @if(!isEditingInvoiceData &&
                        checkMandatoryVariableEmptyStatus(editedPods[i].selectedContractTypeDropdown, true)
                        ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>
                <!-- Invoice network tension -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.network_tension' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(editedPods[i].selectedNetworkTensionDropdown, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-dropdown [options]="networkTensionDropdownOptions"
                                [showOnlyValueWhenDisabled]="true"
                                [(selectedOption)]="editedPods[i].selectedNetworkTensionDropdown"
                                (selectedOptionChange)="onPriceTypeChange(i)" [disabled]="saveClicked"
                                [warningMessage]="networkTensionDropdownWarning[i]" [disabled]="!isEditingInvoiceData"
                                boxHeight="h-[40px]" autoMarginTop="mt-0">
                            </app-custom-dropdown>
                        </div>

                        @if(!isEditingInvoiceData &&
                        checkMandatoryVariableEmptyStatus(editedPods[i].selectedNetworkTensionDropdown,
                        true)
                        ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Invoice tariff code -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.tariff_code' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkVariableEmptyStatus(editedPods[i].tariff_code, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'tariff_code_' + i" autoMarginTop="mt-0"
                                [inputType]="'text'" [(inputValue)]="editedPods[i].tariff_code">
                            </app-labeled-input>
                        </div>
                    </td>
                </tr>

                <!-- Invoice price type -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.price_type' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(editedPods[i].selectedPriceTypeDropdown, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-dropdown [options]="priceTypeDropdownOptions" [showOnlyValueWhenDisabled]="true"
                                [(selectedOption)]="editedPods[i].selectedPriceTypeDropdown"
                                (selectedOptionChange)="onPriceTypeChange(i)" [disabled]="saveClicked"
                                [warningMessage]="priceTypeDropdownWarning[i]" [disabled]="!isEditingInvoiceData"
                                boxHeight="h-[40px]" autoMarginTop="mt-0">
                            </app-custom-dropdown>
                        </div>

                        @if(!isEditingInvoiceData &&
                        checkMandatoryVariableEmptyStatus(editedPods[i].selectedPriceTypeDropdown, true)
                        ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Invoice power kW available -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.power_kw_available' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkVariableEmptyStatus(editedPods[i].power_kw_available, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'power_kw_available_' + i"
                                autoMarginTop="mt-0" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].power_kw_available">
                            </app-custom-number-input>
                        </div>
                    </td>
                </tr>

                <!-- Invoice power kW contracted -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.power_kw_contracted' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="powerKwContractedInputWarnings[i] 
                            ? checkMandatoryVariableEmptyStatus(editedPods[i].power_kw_contracted, true) 
                            : checkVariableEmptyStatus(editedPods[i].power_kw_contracted, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'power_kw_contracted_' + i"
                                autoMarginTop="mt-0" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].power_kw_contracted"
                                [warningMessage]="powerKwContractedInputWarnings[i]"
                                (inputValueLength)="onFieldChange({ value: $event, targetArray: powerKwContractedInputWarnings, podIndex: i, fieldName: 'power_kw_contracted' })">
                            </app-custom-number-input>
                        </div>

                        @if(!isEditingInvoiceData && powerKwContractedInputWarnings[i] &&
                        checkMandatoryVariableEmptyStatus(editedPods[i].power_kw_contracted, true)
                        ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Invoice power kW max consumption -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.power_kw_max_consumption' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="powerKwMaxConsumptionInputWarnings[i] 
                            ? checkMandatoryVariableEmptyStatus(editedPods[i].power_kw_max_consumption, true) 
                            : checkVariableEmptyStatus(editedPods[i].power_kw_max_consumption, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-number-input [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'power_kw_max_consumption_' + i"
                                autoMarginTop="mt-0" [inputType]="'number'" boxHeight="h-[40px]"
                                [(inputValue)]="editedPods[i].power_kw_max_consumption"
                                [warningMessage]="powerKwMaxConsumptionInputWarnings[i]"
                                (inputValueLength)="onFieldChange({ value: $event, targetArray: powerKwMaxConsumptionInputWarnings, podIndex: i, fieldName: 'power_kw_max_consumption' })">
                            </app-custom-number-input>
                        </div>

                        @if(!isEditingInvoiceData && powerKwMaxConsumptionInputWarnings[i] &&
                        checkMandatoryVariableEmptyStatus(editedPods[i].power_kw_max_consumption, true)
                        ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Consumption class -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{'invoice.labels.consumption_class' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkVariableEmptyStatus(editedPods[i].selectedConsumptionClassDropdown, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <div class="min-w-[250px]">
                                <app-custom-dropdown [options]="consumptionClassDropdownOptions"
                                    [showOnlyValueWhenDisabled]="true"
                                    [(selectedOption)]="editedPods[i].selectedConsumptionClassDropdown"
                                    [disabled]="saveClicked" [disabled]="!isEditingInvoiceData" boxHeight="h-[40px]"
                                    autoMarginTop="mt-0">
                                </app-custom-dropdown>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Cost Component Analysis-->
        <div class="w-full p-2 flex flex-col gap-2 bg-neutral-100">
            <p class="text-lg font-bold">{{ 'admin.cost_component_analysis' | transloco }}</p>
            <div class="self-end flex gap-2 flex-wrap items-center">
                <p class="text-sm text-neutral-500">{{ 'admin.view_all_components' | transloco }}</p>
                <app-toggle-button [(toggleButton)]="viewAllComponents"></app-toggle-button>
            </div>

            <table class="table w-full rounded-md">
                <!-- Header -->
                <thead class="bg-neutral-200 text-black font-semibold uppercase">
                    <tr class="max-h-[50px]">
                        <th class="border-b border-border px-4 py-4">{{ 'admin.component_name' |
                            transloco
                            }}</th>
                        <th class="border-b border-border px-4 py-4">{{ 'admin.calculation' |
                            transloco
                            }} (€)</th>
                        <th class="border-b border-border px-4 py-4">{{ 'admin.extraction' |
                            transloco
                            }} (€)</th>
                        <th class="border-b border-border px-4 py-4">{{ 'admin.delta' |
                            transloco
                            }} (€)</th>
                    </tr>
                </thead>
                <!-- Content -->
                <tbody class="bg-[#FFFFFF]">
                    <tr class="max-h-[50px] hover:bg-neutral-300 cursor-pointer"
                        (click)="isTotalMaterialCollapsed = !isTotalMaterialCollapsed">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.</p>
                                <p>{{'admin.total_material_costs' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]=" pod?.calc_data?.total_material_costs === null || pod?.calc_data?.total_material_costs === undefined
                                    ? checkMandatoryVariableEmptyStatus(pod?.calc_data?.total_material_costs)
                                    : checkVariableEmptyStatus(editedPods[i].additionalNoteFields.total_material_cost)">
                                </app-invoice-variable-status>
                                <app-collapse-arrow [isOpen]="isTotalMaterialCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.total_material_costs)) {
                            {{ safeValue(pod?.calc_data?.total_material_costs) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'total_material_costs' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].total_material_costs">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.total_material_costs ?? null"
                                [extractionNumber]="pod.total_material_costs ?? null"></app-delta-value>
                        </td>
                    </tr>

                    @if(isTotalMaterialCollapsed)
                    {
                    @if(getContractType(editedPods[i].selectedContractTypeDropdown) == ContractType.MONO ||
                    viewAllComponents){
                    <!-- Consumption F0-->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.1</p>
                                <p>{{ 'invoice.labels.month_consumption_f0' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].month_consumption_f0)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'month_consumption_f0_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="monthConsumptionF0InputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: monthConsumptionF0InputWarnings, podIndex: i })"
                                    [(inputValue)]="editedPods[i].month_consumption_f0">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(getPriceType(editedPods[i].selectedPriceTypeDropdown) == PriceType.FIX ||
                    viewAllComponents)
                    {
                    <!-- Price Fix F0-->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.2</p>
                                <p>{{ 'invoice.labels.price_fix_f0' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].price_fix_f0)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_fix_f0_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="priceFixF0InputWarnings[i]"
                                    [(inputValue)]="editedPods[i].price_fix_f0"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: priceFixF0InputWarnings, podIndex: i })"
                                    showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    <!-- Network Loss F0-->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.3</p>
                                <p>{{ 'invoice.labels.network_loss_f0' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].additionalNoteFields.network_loss_f0)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.network_loss_f0)) {
                            {{ safeValue(pod?.calc_data?.network_loss_f0) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <!-- Additional Note-->
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'network_loss_f0_note' + i"
                                autoMarginTop="mt-0" [inputType]="'number'" bgColor="bg-purple-100"
                                title="{{ 'admin.additional_note' | transloco }}"
                                [(inputValue)]="editedPods[i].additionalNoteFields.network_loss_f0"
                                [allowCalculator]="true"
                                (trackCalcExprHistoryChange)="onExprChange('network_loss_f0', i, $event)">
                            </app-custom-number-input>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN,]) || viewAllComponents)
                    {
                    <!-- PUN Price F0 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.4</p>
                                <p>{{ 'invoice.labels.pun_price_f0' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].pun_price_f0)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px] flex gap-1 items-center">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="true" [inputId]="'pun_price_f0_' + i" autoMarginTop="mt-0"
                                    [inputType]="'number'"
                                    (inputValueLength)="onFieldChange({value: $event, podIndex: i, fieldName: 'pun_price_f0'})"
                                    [(inputValue)]="editedPods[i].pun_price_f0" showCustomDecimals="1.2-6">
                                </app-custom-number-input>

                                <div class="h-5 w-5 text-blue-700">
                                    <app-info-tooltip
                                        text="{{ 'admin.electricity_pun_gas_market_prices_info' | transloco }}"></app-info-tooltip>
                                </div>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN,]) || viewAllComponents)
                    {
                    <!-- Spread F0 -->
                    <tr class="max-h-[50px] bg-blue-100" #spreadzero>
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.5</p>
                                <p>{{ 'invoice.labels.spread_f0' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].spread_f0)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'spread_f0_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    (inputValueLength)="onFieldChange({value: $event, podIndex: i, fieldName: 'spread_f0'})"
                                    [(inputValue)]="editedPods[i].spread_f0" showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN, PriceType.VAR_PUNH]) ||
                    viewAllComponents)
                    {
                    <!-- Variable Price F0 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.6</p>
                                <p>{{ 'invoice.labels.price_var_f0' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="getPriceVarMonoStatus(
                                        editedPods[i].pun_price_f0,
                                        editedPods[i].spread_f0,
                                        editedPods[i].price_var_f0, getPriceType(editedPods[i].selectedPriceTypeDropdown))">
                                </app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.price_var_f0_calc)) {
                            {{ safeValue(pod?.calc_data?.price_var_f0_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_var_f0_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].price_var_f0"
                                    [warningMessage]="priceVarF0InputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, fieldName: 'price_var_f0', podIndex: i })"
                                    showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.price_var_f0_calc ?? null"
                                [extractionNumber]="pod.price_var_f0"></app-delta-value>
                        </td>
                    </tr>
                    }
                    }

                    @if(getContractType(editedPods[i].selectedContractTypeDropdown) == ContractType.FASCIA ||
                    viewAllComponents){
                    <!-- Consumption F1 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.7</p>
                                <p>{{ 'invoice.labels.month_consumption_f1' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].month_consumption_f1)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'month_consumption_f1_' + i"
                                    [inputType]="'number'" [warningMessage]="monthConsumptionF1InputWarnings[i]"
                                    [(inputValue)]="editedPods[i].month_consumption_f1" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: monthConsumptionF1InputWarnings, podIndex: i })">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(getPriceType(editedPods[i].selectedPriceTypeDropdown) == PriceType.FIX ||
                    viewAllComponents)
                    {
                    <!-- Price Fix F1 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.8</p>
                                <p>{{ 'invoice.labels.price_fix_f1' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].price_fix_f1)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_fix_f1_' + i"
                                    [inputType]="'number'" [(inputValue)]="editedPods[i].price_fix_f1"
                                    [warningMessage]="priceFixF1InputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: priceFixF1InputWarnings, podIndex: i })"
                                    autoMarginTop="mt-0" showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    <!-- Network Loss F1-->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.9</p>
                                <p>{{ 'invoice.labels.network_loss_f1' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].additionalNoteFields.network_loss_f1)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.network_loss_f1)) {
                            {{ safeValue(pod?.calc_data?.network_loss_f1) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <!-- Additional Note-->
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'network_loss_f1_note' + i"
                                autoMarginTop="mt-0" [inputType]="'number'" bgColor="bg-purple-100"
                                title="{{ 'admin.additional_note' | transloco }}"
                                [(inputValue)]="editedPods[i].additionalNoteFields.network_loss_f1"
                                [allowCalculator]="true"
                                (trackCalcExprHistoryChange)="onExprChange('network_loss_f1', i, $event)">
                            </app-custom-number-input>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN,]) || viewAllComponents)
                    {
                    <!-- PUN Price F1 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.10</p>
                                <p>{{ 'invoice.labels.pun_price_f1' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkPunPriceLookupStatus(editedPods[i].pun_price_f1, [editedPods[i].pun_price_f1, editedPods[i].pun_price_f2, editedPods[i].pun_price_f3])"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px] flex gap-1 items-center">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="true" [inputId]="'pun_price_f1_' + i" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].pun_price_f1"
                                    (inputValueLength)="onFieldChange({value: $event, podIndex: i, fieldName: 'pun_price_f1'})"
                                    autoMarginTop="mt-0" showCustomDecimals="1.2-6">
                                </app-custom-number-input>

                                <div class="h-5 w-5 text-blue-700">
                                    <app-info-tooltip
                                        text="{{ 'admin.electricity_pun_gas_market_prices_info' | transloco }}"></app-info-tooltip>
                                </div>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN,]) || viewAllComponents)
                    {
                    <!-- Spread F1 -->
                    <tr class="max-h-[50px] bg-blue-100" #spreadone>
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.11</p>
                                <p>{{ 'invoice.labels.spread_f1' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].spread_f1)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'spread_f1_' + i"
                                    [inputType]="'number'" [(inputValue)]="editedPods[i].spread_f1" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({value: $event, podIndex: i, fieldName: 'spread_f1'})"
                                    showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN, PriceType.VAR_PUNH,]) || viewAllComponents)
                    {
                    <!-- Price Var F1 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.12</p>
                                <p>{{ 'invoice.labels.price_var_f1' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="getPriceVarFasciaStatus(
                                        editedPods[i].pun_price_f1, editedPods[i].spread_f1,
                                        editedPods[i].pun_price_f2, editedPods[i].spread_f2,
                                        editedPods[i].pun_price_f3, editedPods[i].spread_f3,
                                        editedPods[i].price_var_f1, getPriceType(editedPods[i].selectedPriceTypeDropdown))">
                                </app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.price_var_f1_calc)) {
                            {{ safeValue(pod?.calc_data?.price_var_f1_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_var_f1_' + i"
                                    [inputType]="'number'" [warningMessage]="priceVarF1InputWarnings[i]"
                                    [(inputValue)]="editedPods[i].price_var_f1" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({ value: $event, fieldName: 'price_var_f1', podIndex: i })"
                                    showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.price_var_f1_calc ?? null"
                                [extractionNumber]="pod.price_var_f1"></app-delta-value>
                        </td>
                    </tr>
                    }

                    <!-- Consumption F2 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.13</p>
                                <p>{{ 'invoice.labels.month_consumption_f2' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].month_consumption_f2)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'month_consumption_f2_' + i"
                                    [inputType]="'number'" [warningMessage]="monthConsumptionF2InputWarnings[i]"
                                    [(inputValue)]="editedPods[i].month_consumption_f2" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: monthConsumptionF2InputWarnings, podIndex: i })">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(getPriceType(editedPods[i].selectedPriceTypeDropdown) == PriceType.FIX ||
                    viewAllComponents)
                    {
                    <!-- Price Fix F2 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.14</p>
                                <p>{{ 'invoice.labels.price_fix_f2' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].price_fix_f2)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_fix_f2_' + i"
                                    [inputType]="'number'" [(inputValue)]="editedPods[i].price_fix_f2"
                                    [warningMessage]="priceFixF2InputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: priceFixF2InputWarnings, podIndex: i })"
                                    autoMarginTop="mt-0" showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    <!-- Network Loss F2-->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.15</p>
                                <p>{{ 'invoice.labels.network_loss_f2' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].additionalNoteFields.network_loss_f2)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.network_loss_f2)) {
                            {{ safeValue(pod?.calc_data?.network_loss_f2) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <!-- Additional Note-->
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'network_loss_f2_note' + i"
                                autoMarginTop="mt-0" [inputType]="'number'" bgColor="bg-purple-100"
                                title="{{ 'admin.additional_note' | transloco }}"
                                [(inputValue)]="editedPods[i].additionalNoteFields.network_loss_f2"
                                [allowCalculator]="true"
                                (trackCalcExprHistoryChange)="onExprChange('network_loss_f2', i, $event)">
                            </app-custom-number-input>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN,]) || viewAllComponents)
                    {
                    <!-- PUN Price F2 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.15</p>
                                <p>{{ 'invoice.labels.pun_price_f2' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkPunPriceLookupStatus(editedPods[i].pun_price_f2, [editedPods[i].pun_price_f1, editedPods[i].pun_price_f2, editedPods[i].pun_price_f3])"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px] flex gap-1 items-center">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="true" [inputId]="'pun_price_f2_' + i" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].pun_price_f2"
                                    (inputValueLength)="onFieldChange({value: $event, podIndex: i, fieldName: 'pun_price_f2'})"
                                    autoMarginTop="mt-0" showCustomDecimals="1.2-6">
                                </app-custom-number-input>

                                <div class="h-5 w-5 text-blue-700">
                                    <app-info-tooltip
                                        text="{{ 'admin.electricity_pun_gas_market_prices_info' | transloco }}"></app-info-tooltip>
                                </div>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN,]) || viewAllComponents)
                    {
                    <!-- Spread F2 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.16</p>
                                <p>{{ 'invoice.labels.spread_f2' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].spread_f2)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'spread_f2_' + i"
                                    [inputType]="'number'" [(inputValue)]="editedPods[i].spread_f2" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({value: $event, podIndex: i, fieldName: 'spread_f2'})"
                                    showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN, PriceType.VAR_PUNH,]) || viewAllComponents)
                    {
                    <!-- Price Var F2 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.17</p>
                                <p>{{ 'invoice.labels.price_var_f2' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="getPriceVarFasciaStatus(
                                        editedPods[i].pun_price_f1, editedPods[i].spread_f1,
                                        editedPods[i].pun_price_f2, editedPods[i].spread_f2,
                                        editedPods[i].pun_price_f3, editedPods[i].spread_f3,
                                        editedPods[i].price_var_f2, getPriceType(editedPods[i].selectedPriceTypeDropdown))">
                                </app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.price_var_f2_calc)) {
                            {{ safeValue(pod?.calc_data?.price_var_f2_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_var_f2_' + i"
                                    [inputType]="'number'" [warningMessage]="priceVarF2InputWarnings[i]"
                                    [(inputValue)]="editedPods[i].price_var_f2" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({ value: $event, fieldName: 'price_var_f2', podIndex: i })"
                                    showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.price_var_f2_calc ?? null"
                                [extractionNumber]="pod.price_var_f2"></app-delta-value>
                        </td>
                    </tr>
                    }

                    <!-- Consumption F3 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.18</p>
                                <p>{{ 'invoice.labels.month_consumption_f3' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].month_consumption_f3)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'month_consumption_f3_' + i"
                                    [inputType]="'number'" [warningMessage]="monthConsumptionF3InputWarnings[i]"
                                    [(inputValue)]="editedPods[i].month_consumption_f3" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: monthConsumptionF3InputWarnings, podIndex: i })">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(getPriceType(editedPods[i].selectedPriceTypeDropdown) == PriceType.FIX ||
                    viewAllComponents)
                    {
                    <!-- Price Fix F3 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.19</p>
                                <p>{{ 'invoice.labels.price_fix_f3' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].price_fix_f3)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_fix_f3_' + i"
                                    [inputType]="'number'" [(inputValue)]="editedPods[i].price_fix_f3"
                                    [warningMessage]="priceFixF3InputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: priceFixF3InputWarnings, podIndex: i })"
                                    autoMarginTop="mt-0" showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    <!-- Network Loss F3-->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.20</p>
                                <p>{{ 'invoice.labels.network_loss_f3' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].additionalNoteFields.network_loss_f3)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.network_loss_f3)) {
                            {{ safeValue(pod?.calc_data?.network_loss_f3) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <!-- Additional Note-->
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'network_loss_f3_note' + i"
                                autoMarginTop="mt-0" [inputType]="'number'" bgColor="bg-purple-100"
                                title="{{ 'admin.additional_note' | transloco }}"
                                [(inputValue)]="editedPods[i].additionalNoteFields.network_loss_f3"
                                [allowCalculator]="true"
                                (trackCalcExprHistoryChange)="onExprChange('network_loss_f3', i, $event)">
                            </app-custom-number-input>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN,]) || viewAllComponents)
                    {
                    <!-- PUN Price F3 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.21</p>
                                <p>{{ 'invoice.labels.pun_price_f3' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkPunPriceLookupStatus(editedPods[i].pun_price_f3, [editedPods[i].pun_price_f1, editedPods[i].pun_price_f2, editedPods[i].pun_price_f3])"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px] flex gap-1 items-center">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="true" [inputId]="'pun_price_f3_' + i" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].pun_price_f3"
                                    (inputValueLength)="onFieldChange({value: $event, podIndex: i, fieldName: 'pun_price_f3'})"
                                    autoMarginTop="mt-0" showCustomDecimals="1.2-6">
                                </app-custom-number-input>

                                <div class="h-5 w-5 text-blue-700">
                                    <app-info-tooltip
                                        text="{{ 'admin.electricity_pun_gas_market_prices_info' | transloco }}"></app-info-tooltip>
                                </div>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN,]) || viewAllComponents)
                    {
                    <!-- Spread F3 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.22</p>
                                <p>{{ 'invoice.labels.spread_f3' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].spread_f3)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'spread_f3_' + i"
                                    [inputType]="'number'" [(inputValue)]="editedPods[i].spread_f3" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({value: $event, podIndex: i, fieldName: 'spread_f3'})"
                                    showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN, PriceType.VAR_PUNH,]) || viewAllComponents)
                    {
                    <!-- Price Var F3 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.23</p>
                                <p>{{ 'invoice.labels.price_var_f3' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="getPriceVarFasciaStatus(
                                        editedPods[i].pun_price_f1, editedPods[i].spread_f1,
                                        editedPods[i].pun_price_f2, editedPods[i].spread_f2,
                                        editedPods[i].pun_price_f3, editedPods[i].spread_f3,
                                        editedPods[i].price_var_f3, getPriceType(editedPods[i].selectedPriceTypeDropdown))">
                                </app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.price_var_f3_calc)) {
                            {{ safeValue(pod?.calc_data?.price_var_f3_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_var_f3_' + i"
                                    [inputType]="'number'" [warningMessage]="priceVarF3InputWarnings[i]"
                                    [(inputValue)]="editedPods[i].price_var_f3" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({ value: $event, fieldName: 'price_var_f3', podIndex: i })"
                                    showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.price_var_f3_calc ?? null"
                                [extractionNumber]="pod.price_var_f3"></app-delta-value>
                        </td>
                    </tr>
                    }
                    }

                    @if(getContractType(editedPods[i].selectedContractTypeDropdown) == ContractType.PICCO ||
                    viewAllComponents){
                    <!-- Consumption P-->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.24</p>
                                <p>{{ 'invoice.labels.month_consumption_p' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].month_consumption_p)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'month_consumption_p_' + i"
                                    [inputType]="'number'" [warningMessage]="monthConsumptionPInputWarnings[i]"
                                    [(inputValue)]="editedPods[i].month_consumption_p" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: monthConsumptionPInputWarnings, podIndex: i })">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.FIX]) ||
                    viewAllComponents)
                    {
                    <!-- Price Fix P-->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.25</p>
                                <p>{{ 'invoice.labels.price_fix_p' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].price_fix_p)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_fix_p_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="priceFixPInputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: priceFixPInputWarnings, podIndex: i })"
                                    [(inputValue)]="editedPods[i].price_fix_p" showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    <!-- Network Loss P-->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.26</p>
                                <p>{{ 'invoice.labels.network_loss_p' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].additionalNoteFields.network_loss_p)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.network_loss_p)) {
                            {{ safeValue(pod?.calc_data?.network_loss_p) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <!-- Additional Note-->
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'network_loss_p_note' + i"
                                autoMarginTop="mt-0" [inputType]="'number'" bgColor="bg-purple-100"
                                title="{{ 'admin.additional_note' | transloco }}"
                                [(inputValue)]="editedPods[i].additionalNoteFields.network_loss_p"
                                [allowCalculator]="true"
                                (trackCalcExprHistoryChange)="onExprChange('network_loss_p', i, $event)">
                            </app-custom-number-input>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN,]) || viewAllComponents)
                    {
                    <!-- PUN Price P -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.27</p>
                                <p>{{ 'invoice.labels.pun_price_p' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].pun_price_p)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px] flex gap-1 items-center">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="true" [inputId]="'pun_price_p_' + i" autoMarginTop="mt-0"
                                    [inputType]="'number'"
                                    (inputValueLength)="onFieldChange({value: $event, podIndex: i, fieldName: 'pun_price_p'})"
                                    [(inputValue)]="editedPods[i].pun_price_p" showCustomDecimals="1.2-6">
                                </app-custom-number-input>

                                <div class="h-5 w-5 text-blue-700">
                                    <app-info-tooltip
                                        text="{{ 'admin.electricity_pun_gas_market_prices_info' | transloco }}"></app-info-tooltip>
                                </div>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN,]) || viewAllComponents)
                    {
                    <!-- Spread P -->
                    <tr class="max-h-[50px] bg-blue-100" #spreadp>
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.28</p>
                                <p>{{ 'invoice.labels.spread_p' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].spread_p)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'spread_p_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="editedPods[i].spread_p"
                                    (inputValueLength)="onFieldChange({value: $event, podIndex: i, fieldName: 'spread_p'})"
                                    showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN, PriceType.VAR_PUNH,]) ||
                    viewAllComponents)
                    {
                    <!-- Variable Price P -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.29</p>
                                <p>{{ 'invoice.labels.price_var_p' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="getPriceVarPiccoStatus(
                                        editedPods[i].pun_price_p, editedPods[i].spread_p,
                                        editedPods[i].pun_price_po, editedPods[i].spread_po,
                                        editedPods[i].price_var_p, getPriceType(editedPods[i].selectedPriceTypeDropdown))">
                                </app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.price_var_p_calc)) {
                            {{ safeValue(pod?.calc_data?.price_var_p_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_var_p_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].price_var_p"
                                    [warningMessage]="priceVarPInputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, fieldName: 'price_var_p', podIndex: i })"
                                    showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.price_var_p_calc ?? null"
                                [extractionNumber]="pod.price_var_p"></app-delta-value>
                        </td>
                    </tr>
                    }

                    <!-- Consumption Po -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.30</p>
                                <p>{{ 'invoice.labels.month_consumption_po' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].month_consumption_po)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'month_consumption_po_' + i"
                                    [inputType]="'number'" [warningMessage]="monthConsumptionPoInputWarnings[i]"
                                    [(inputValue)]="editedPods[i].month_consumption_po" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: monthConsumptionPoInputWarnings, podIndex: i })">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.FIX]) ||
                    viewAllComponents)
                    {
                    <!-- Price Fix Po-->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.31</p>
                                <p>{{ 'invoice.labels.price_fix_po' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].price_fix_po)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_fix_po_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="priceFixPoInputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: priceFixPoInputWarnings, podIndex: i })"
                                    [(inputValue)]="editedPods[i].price_fix_po" showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    <!-- Network Loss Po-->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.32</p>
                                <p>{{ 'invoice.labels.network_loss_po' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].additionalNoteFields.network_loss_po)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.network_loss_po)) {
                            {{ safeValue(pod?.calc_data?.network_loss_po) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <!-- Additional Note-->
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'network_loss_po_note' + i"
                                autoMarginTop="mt-0" [inputType]="'number'" bgColor="bg-purple-100"
                                title="{{ 'admin.additional_note' | transloco }}"
                                [(inputValue)]="editedPods[i].additionalNoteFields.network_loss_po"
                                [allowCalculator]="true"
                                (trackCalcExprHistoryChange)="onExprChange('network_loss_po', i, $event)">
                            </app-custom-number-input>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN,]) || viewAllComponents)
                    {
                    <!-- PUN Price Po -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.33</p>
                                <p>{{ 'invoice.labels.pun_price_po' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].pun_price_po)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px] flex gap-1 items-center">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="true" [inputId]="'pun_price_po_' + i" autoMarginTop="mt-0"
                                    [inputType]="'number'"
                                    (inputValueLength)="onFieldChange({value: $event, podIndex: i, fieldName: 'pun_price_po'})"
                                    [(inputValue)]="editedPods[i].pun_price_po" showCustomDecimals="1.2-6">
                                </app-custom-number-input>

                                <div class="h-5 w-5 text-blue-700">
                                    <app-info-tooltip
                                        text="{{ 'admin.electricity_pun_gas_market_prices_info' | transloco }}"></app-info-tooltip>
                                </div>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN,]) || viewAllComponents)
                    {
                    <!-- Spread Po -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.34</p>
                                <p>{{ 'invoice.labels.spread_po' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].spread_po)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'spread_po_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="editedPods[i].spread_po"
                                    (inputValueLength)="onFieldChange({value: $event, podIndex: i, fieldName: 'spread_po'})"
                                    showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    @if(isOneOf(getPriceType(editedPods[i].selectedPriceTypeDropdown), [PriceType.VAR,
                    PriceType.VAR_PUN, PriceType.VAR_PUNH]) || viewAllComponents)
                    {
                    <!-- Variable Price Po -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.35</p>
                                <p>{{ 'invoice.labels.price_var_po' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="getPriceVarPiccoStatus(
                                        editedPods[i].pun_price_p, editedPods[i].spread_p,
                                        editedPods[i].pun_price_po, editedPods[i].spread_po,
                                        editedPods[i].price_var_po, getPriceType(editedPods[i].selectedPriceTypeDropdown))">
                                </app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.price_var_po_calc)) {
                            {{ safeValue(pod?.calc_data?.price_var_po_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_var_po_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].price_var_po"
                                    [warningMessage]="priceVarPInputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, fieldName: 'price_var_po', podIndex: i })"
                                    showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.price_var_po_calc ?? null"
                                [extractionNumber]="pod.price_var_po"></app-delta-value>
                        </td>
                    </tr>
                    }

                    <!-- Invoice total consumption -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.36</p>
                                <p>{{ 'invoice.labels.total_consumption' | transloco }} kWh</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(invoice?.total_consumption)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.total_consumption_calc)) {
                            {{ safeValue(pod?.calc_data?.total_consumption_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'totalConsumption'"
                                    autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="totalConsumptionInput"
                                    [errorMessage]="totalConsumptionInputError"
                                    placeholder="{{ 'invoice.placeholders.total_consumption' | transloco }}"
                                    (inputValueLength)="onFieldChange({ value: $event, fieldName: 'totalConsumption'})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.total_consumption_calc ?? null"
                                [extractionNumber]="invoice?.total_consumption ?? null"></app-delta-value>
                        </td>
                    </tr>}

                    <!-- Tension Factor -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.37</p>
                                <p>{{ 'invoice.labels.tension_factor' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].tension_factor)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'tension_factor_' + i"
                                    [inputType]="'number'" [warningMessage]="tensionFactorInputWarnings[i]"
                                    [(inputValue)]="editedPods[i].tension_factor" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: tensionFactorInputWarnings, podIndex: i })">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Modulation Charge -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.38</p>
                                <p>{{ 'invoice.labels.modulation_charge' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'modulation_charge' + i"
                                    [inputType]="'number'" [warningMessage]="tensionFactorInputWarnings[i]"
                                    [(inputValue)]="editedPods[i].modulation_charge" autoMarginTop="mt-0">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    <tr class="max-h-[50px] hover:bg-neutral-300 cursor-pointer"
                        (click)="isDispatchAndMarketCapCollapsed = !isDispatchAndMarketCapCollapsed">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.</p>
                                <p>{{'admin.dispatch_and_market_cap' | transloco}}</p>
                                <app-collapse-arrow [isOpen]="isDispatchAndMarketCapCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <!-- Additional Note-->
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'dispatch_and_market_cap' + i"
                                autoMarginTop="mt-0" [inputType]="'number'" bgColor="bg-purple-100"
                                title="{{ 'admin.additional_note' | transloco }}"
                                [(inputValue)]="editedPods[i].additionalNoteFields.dispatch_and_marketing_capacity"
                                [allowCalculator]="true"
                                (trackCalcExprHistoryChange)="onExprChange('dispatch_and_marketing_capacity', i, $event)">
                            </app-custom-number-input>
                        </td>
                        <td class=" border-b border-border px-4 py-4">
                            -
                        </td>
                        <td class="border-b border-border px-4 py-4">

                        </td>
                    </tr>

                    @if(isDispatchAndMarketCapCollapsed)
                    {
                    <!-- Dispatch Costs -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.1</p>
                                <p>{{ 'invoice.labels.dispatch_costs' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].dispatch_costs)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'dispatch_costs_' + i"
                                    [inputType]="'number'" [(inputValue)]="editedPods[i].dispatch_costs"
                                    autoMarginTop="mt-0">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Market Capacity P -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.2</p>
                                <p>{{ 'invoice.labels.market_capacity_p' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].market_capacity_p)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'market_capacity_p_' + i"
                                    [inputType]="'number'" [(inputValue)]="editedPods[i].market_capacity_p"
                                    autoMarginTop="mt-0">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Market Capacity OP -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3</p>
                                <p>{{ 'invoice.labels.market_capacity_op' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].market_capacity_op)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'market_capacity_op_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].market_capacity_op">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Dispatching Factor -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.4</p>
                                <p>{{ 'invoice.labels.dispatching_factor' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].dispatching_factor)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'dispatching_factor_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].dispatching_factor">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    }

                    <tr class="max-h-[50px] hover:bg-neutral-300 cursor-pointer"
                        (click)="isTMSCollapsed = !isTMSCollapsed">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.</p>
                                <p>{{'shared.tms' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="pod?.calc_data?.tms_charges_calc === null || pod?.calc_data?.tms_charges_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pod?.calc_data?.tms_charges_calc)
                                    : checkMandatoryVariableEmptyStatus(editedPods[i].tms_charges)"></app-invoice-variable-status>
                                <app-collapse-arrow [isOpen]="isTMSCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.tms_charges_calc)) {
                            {{ safeValue(pod?.calc_data?.tms_charges_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'tms_charges' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].tms_charges"
                                    [warningMessage]="tmsChargesInputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: tmsChargesInputWarnings, podIndex: i })">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.tms_charges_calc ?? null"
                                [extractionNumber]="pod.tms_charges"></app-delta-value>
                        </td>
                    </tr>
                    @if(isTMSCollapsed)
                    {
                    <!-- Fixed Charge -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.1</p>
                                <p>{{ 'invoice.labels.fixed_charge' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].fixed_charge)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'fixed_charge_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].fixed_charge">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Energy charge -->
                    <tr class="max-h-[50px] bg-blue-100 cursor-pointer hover:bg-blue-200"
                        (click)="isEnergyChargeCollapsed=!isEnergyChargeCollapsed">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.2</p>
                                <p>{{ 'invoice.labels.energy_charge' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].additionalNoteFields.energy_charge)"></app-invoice-variable-status>
                                <app-collapse-arrow [isOpen]="isEnergyChargeCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.energy_charge)) {
                            {{ safeValue(pod?.calc_data?.energy_charge) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <!-- Additional Note-->
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'energy_charge_note' + i"
                                autoMarginTop="mt-0" [inputType]="'number'" bgColor="bg-purple-100"
                                title="{{ 'admin.additional_note' | transloco }}"
                                [(inputValue)]="editedPods[i].additionalNoteFields.energy_charge"
                                [allowCalculator]="true"
                                (trackCalcExprHistoryChange)="onExprChange('energy_charge', i, $event)">
                            </app-custom-number-input>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(isEnergyChargeCollapsed)
                    {
                    <!-- Energy Charge Price -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.2.1</p>
                                <p>{{ 'invoice.labels.energy_charge_price' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].energy_charge_price)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'energy_charge_price_' + i"
                                    [inputType]="'number'" [warningMessage]="energyChargePriceInputWarnings[i]"
                                    [(inputValue)]="editedPods[i].energy_charge_price" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: energyChargePriceInputWarnings, podIndex: i })">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Invoice total consumption -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.2.2</p>
                                <p>{{ 'invoice.labels.total_consumption' | transloco }} kWh</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(invoice?.total_consumption)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.total_consumption_calc)) {
                            {{ safeValue(pod?.calc_data?.total_consumption_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'totalConsumption'"
                                    autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="totalConsumptionInput"
                                    [errorMessage]="totalConsumptionInputError"
                                    [warningMessage]="totalConsumptionInputWarning"
                                    placeholder="{{ 'invoice.placeholders.total_consumption' | transloco }}"
                                    (inputValueLength)="onFieldChange({ value: $event, fieldName: 'totalConsumption'})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.total_consumption_calc ?? null"
                                [extractionNumber]="invoice?.total_consumption ?? null"></app-delta-value>
                        </td>
                    </tr>
                    }

                    <!-- Power Charge -->
                    <tr class="max-h-[50px] bg-blue-100 cursor-pointer hover:bg-blue-200"
                        (click)="isPowerChargeCollapsed=!isPowerChargeCollapsed">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.3</p>
                                <p>{{ 'invoice.labels.power_charge' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].additionalNoteFields.power_charge)"></app-invoice-variable-status>
                                <app-collapse-arrow [isOpen]="isPowerChargeCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.power_charge)) {
                            {{ safeValue(pod?.calc_data?.power_charge) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <!-- Additional Note-->
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'power_charge_note' + i"
                                autoMarginTop="mt-0" [inputType]="'number'" bgColor="bg-purple-100"
                                title="{{ 'admin.additional_note' | transloco }}"
                                [(inputValue)]="editedPods[i].additionalNoteFields.power_charge"
                                [allowCalculator]="true"
                                (trackCalcExprHistoryChange)="onExprChange('power_charge_note', i, $event)">
                            </app-custom-number-input>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(isPowerChargeCollapsed)
                    {
                    <!-- Power Charge Price -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.3.1</p>
                                <p>{{ 'invoice.labels.power_charge_price' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].power_charge_price)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'power_charge_price_' + i"
                                    [inputType]="'number'" [warningMessage]="powerChargePriceInputWarnings[i]"
                                    [(inputValue)]="editedPods[i].power_charge_price" autoMarginTop="mt-0"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: powerChargePriceInputWarnings, podIndex: i })">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Invoice power kW contracted -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.3.2</p>
                                <p>{{ 'invoice.labels.power_kw_contracted' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].power_kw_contracted)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'power_kw_contracted_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].power_kw_contracted"
                                    [warningMessage]="powerKwContractedInputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: powerKwContractedInputWarnings, podIndex: i, fieldName: 'power_kw_contracted' })">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Invoice power kW max consumption -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.3.3</p>
                                <p>{{ 'invoice.labels.power_kw_max_consumption' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].power_kw_max_consumption)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'power_kw_max_consumption_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].power_kw_max_consumption"
                                    [warningMessage]="powerKwMaxConsumptionInputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: powerKwMaxConsumptionInputWarnings, podIndex: i, fieldName: 'power_kw_max_consumption' })">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Invoice power kW max consumption -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.3.4</p>
                                <p>{{ 'invoice.labels.network_tension' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].selectedNetworkTensionDropdown)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-dropdown [options]="networkTensionDropdownOptions"
                                    [showOnlyValueWhenDisabled]="true"
                                    [(selectedOption)]="editedPods[i].selectedNetworkTensionDropdown"
                                    (selectedOptionChange)="onPriceTypeChange(i)" [disabled]="saveClicked"
                                    [warningMessage]="networkTensionDropdownWarning[i]"
                                    [disabled]="!isEditingInvoiceData" boxHeight="h-[40px]" autoMarginTop="mt-0">
                                </app-custom-dropdown>
                            </div>

                            @if(!isEditingInvoiceData &&
                            checkMandatoryVariableEmptyStatus(editedPods[i].selectedNetworkTensionDropdown,
                            true)
                            ==
                            InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    <!-- Reactive Energy Costs -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.4</p>
                                <p>{{ 'invoice.labels.reactive_energy_costs' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].reactive_energy_costs)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'reactive_energy_costs_' + i"
                                    [inputType]="'number'" [(inputValue)]="editedPods[i].reactive_energy_costs"
                                    autoMarginTop="mt-0">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    <tr class="max-h-[50px] hover:bg-neutral-300 cursor-pointer"
                        (click)="isTaxesCollapsed = !isTaxesCollapsed">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">4.</p>
                                <p>{{'invoice.labels.total_taxes' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="pod?.calc_data?.total_taxes_calc === null || pod?.calc_data?.total_taxes_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pod?.calc_data?.total_taxes_calc)
                                    : checkMandatoryVariableEmptyStatus(editedPods[i].total_taxes)"></app-invoice-variable-status>
                                <app-collapse-arrow [isOpen]="isTaxesCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.total_taxes_calc)) {
                            {{ safeValue(pod?.calc_data?.total_taxes_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <div class="min-w-[250px]">
                                    <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                        [isDisabled]="!isEditingInvoiceData" [inputId]="'total_taxes' + i"
                                        [inputType]="'number'" [warningMessage]="totalTaxesInputWarnings[i]"
                                        [(inputValue)]="editedPods[i].total_taxes" autoMarginTop="mt-0"
                                        placeholder="{{ 'invoice.placeholders.total_taxes' | transloco }}"
                                        (inputValueLength)="onFieldChange({ value: $event, targetArray: totalTaxesInputWarnings, podIndex: i })">
                                    </app-custom-number-input>
                                </div>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.total_taxes_calc ?? null"
                                [extractionNumber]="pod.total_taxes"></app-delta-value>
                        </td>
                    </tr>
                    @if(isTaxesCollapsed)
                    {
                    <!-- Tax Rate 1 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">4.1</p>
                                <p>{{ 'invoice.labels.taxrate_1' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].taxrate_1)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'taxrate_1_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="editedPods[i].taxrate_1"
                                    [warningMessage]="taxRate1InputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: taxRate1InputWarnings, podIndex: i })"
                                    showCustomDecimals="1.2-4">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Tax Rate 2 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">4.2</p>
                                <p>{{ 'invoice.labels.taxrate_2' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPods[i].taxrate_2)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'taxrate_2_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="editedPods[i].taxrate_2"
                                    [warningMessage]="taxRate2InputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: taxRate2InputWarnings, podIndex: i })"
                                    showCustomDecimals="1.2-4">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Invoice total consumption -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">4.3</p>
                                <p>{{ 'invoice.labels.total_consumption' | transloco }} kWh</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(invoice?.total_consumption)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.total_consumption_calc)) {
                            {{ safeValue(pod?.calc_data?.total_consumption_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'totalConsumption'"
                                    autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="totalConsumptionInput"
                                    [errorMessage]="totalConsumptionInputError"
                                    [warningMessage]="totalConsumptionInputWarning"
                                    placeholder="{{ 'invoice.placeholders.total_consumption' | transloco }}"
                                    (inputValueLength)="onFieldChange({ value: $event, fieldName: 'totalConsumption'})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.total_consumption_calc ?? null"
                                [extractionNumber]="invoice?.total_consumption ?? null"></app-delta-value>
                        </td>
                    </tr>
                    }

                    <tr class="max-h-[50px] hover:bg-neutral-300 cursor-pointer"
                        (click)="isInvoiceChargesCollapsed = !isInvoiceChargesCollapsed">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">5.</p>
                                <p>{{'admin.invoice_charges' | transloco}}</p>
                                <app-collapse-arrow [isOpen]="isInvoiceChargesCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <!-- Additional Note-->
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'invoice_charges_note' + i"
                                autoMarginTop="mt-0" [inputType]="'number'" bgColor="bg-purple-100"
                                title="{{ 'admin.additional_note' | transloco }}"
                                [(inputValue)]="editedPods[i].additionalNoteFields.invoice_charges"
                                [allowCalculator]="true"
                                (trackCalcExprHistoryChange)="onExprChange('invoice_charges', i, $event)">
                            </app-custom-number-input>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <td class="border-b border-border px-4 py-4">

                        </td>
                    </tr>

                    @if(isInvoiceChargesCollapsed)
                    {
                    <!-- Fixed Costs -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">5.1</p>
                                <p>{{ 'invoice.labels.fixed_costs' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].fixed_costs)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'fixed_costs_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].fixed_costs">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Additional Charges -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">5.2</p>
                                <p>{{ 'invoice.labels.additional_charges' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].additional_charges)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'additional_charges_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPods[i].additional_charges">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Invoice total discount amount -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">5.3</p>
                                <p>{{ 'invoice.labels.total_discount_amount' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(totalDiscountInput)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'totalDiscount'" autoMarginTop="mt-0"
                                [inputType]="'number'" [(inputValue)]="totalDiscountInput"
                                [errorMessage]="totalDiscountInputError">
                            </app-custom-number-input>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Invoice nontaxable amount -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">5.4</p>
                                <p>{{ 'invoice.labels.nontaxable_amount' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(nontaxableAmountInput)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'nontaxableAmount'" autoMarginTop="mt-0"
                                [inputType]="'number'" [(inputValue)]="nontaxableAmountInput"
                                [errorMessage]="nontaxableAmountInputError">
                            </app-custom-number-input>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    }

                    <tr class="max-h-[50px] ">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">6.</p>
                                <p>{{'invoice.labels.amount_actual' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="pod?.calc_data?.invoice_amount_net_calc === null || pod?.calc_data?.invoice_amount_net_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pod?.calc_data?.invoice_amount_net_calc)
                                    : checkMandatoryVariableEmptyStatus(invoiceAmountActualInput)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.invoice_amount_net_calc)) {
                            {{ safeValue(pod?.calc_data?.invoice_amount_net_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'invoiceAmountActual'"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="invoiceAmountActualInput"
                                    [errorMessage]="invoiceAmountActualInputError"
                                    [warningMessage]="invoiceAmountActualInputWarning"
                                    placeholder="{{ 'invoice.placeholders.amount' | transloco }}"
                                    (inputValueLength)="onFieldChange({ value: $event, fieldName: 'invoiceAmountActual' })">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.invoice_amount_net_calc ?? null"
                                [extractionNumber]="invoice?.invoice_amount_net_actual ?? null" [pod]="pod"
                                [invoice]="invoice"></app-delta-value>
                        </td>
                    </tr>

                    <tr class="max-h-[50px] hover:bg-neutral-300 cursor-pointer"
                        (click)="isVATCollapsed = !isVATCollapsed">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">7.</p>
                                <p>{{'invoice.labels.vat_amount' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="pod?.calc_data?.vat_amount_calc === null || pod?.calc_data?.vat_amount_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pod?.calc_data?.vat_amount_calc)
                                    : checkVariableEmptyStatus(editedPods[i].vat_amount_actual)"></app-invoice-variable-status>
                                <app-collapse-arrow [isOpen]="isVATCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.vat_amount_calc)) {
                            {{ safeValue(pod?.calc_data?.vat_amount_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <div class="min-w-[250px]">
                                    <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                        [isDisabled]="!isEditingInvoiceData" [inputId]="'vat_amount_actual' + i"
                                        autoMarginTop="mt-0" [inputType]="'number'"
                                        [(inputValue)]="editedPods[i].vat_amount_actual">
                                    </app-custom-number-input>
                                </div>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.vat_amount_calc ?? null"
                                [extractionNumber]="pod.vat_amount_actual" [pod]="pod"
                                [invoice]="invoice"></app-delta-value>
                        </td>
                    </tr>
                    @if(isVATCollapsed)
                    {
                    <!-- Invoice VAT Rate -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">7.1</p>
                                <p>{{ 'invoice.labels.vat_rate' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPods[i].vat_rate)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(invoice?.expected_vat_rate)) {
                            {{ safeValue(invoice?.expected_vat_rate) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'vat_ratey' + i"
                                    autoMarginTop="mt-0"
                                    placeholder="{{ 'invoice.placeholders.enter_as_decimal' | transloco }}"
                                    [inputType]="'text'" [(inputValue)]="editedPods[i].vat_rate">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="invoice?.expected_vat_rate ?? null"
                                [extractionNumber]="pod.vat_rate"></app-delta-value>
                        </td>
                    </tr>

                    }

                    <tr class="max-h-[50px] ">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">8.</p>
                                <p>{{'invoice.labels.amount_gross' | transloco}}</p>
                                <app-invoice-variable-status [status]="pod?.calc_data?.invoice_amount_gross_calc === null || pod?.calc_data?.invoice_amount_gross_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pod?.calc_data?.invoice_amount_gross_calc)
                                    : checkVariableEmptyStatus(invoiceAmountGrossInput)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pod?.calc_data?.invoice_amount_gross_calc)) {
                            {{ safeValue(pod?.calc_data?.invoice_amount_gross_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'invoiceAmountGross'"
                                    autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="invoiceAmountGrossInput"
                                    [errorMessage]="invoiceAmountGrossInputError"
                                    placeholder="{{ 'invoice.placeholders.amount' | transloco }}">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pod.calc_data?.invoice_amount_gross_calc ?? null"
                                [extractionNumber]="invoice?.invoice_amount_gross_actual ?? null" [pod]="pod"
                                [invoice]="invoice"></app-delta-value>
                        </td>
                    </tr>
                    <tr class="max-h-[50px] hover:bg-neutral-300 cursor-pointer"
                        (click)="isSupplierCollapsed = !isSupplierCollapsed">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">9.</p>
                                <p>{{'invoice.sections.supplier_details' | transloco}}</p>
                                <app-collapse-arrow [isOpen]="isSupplierCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <p>{{ editedPods[i].supplierData.name || '' }}</p>
                        </td>
                        <td class="border-b border-border px-4 py-4">

                        </td>
                    </tr>
                    @if(isSupplierCollapsed)
                    {
                    <!-- Supplier Name -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">9.1</p>
                                <p>{{ 'invoice.labels.supplier_name' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'supplier_name_' + i"
                                    autoMarginTop="mt-0" [inputType]="'text'"
                                    [(inputValue)]="editedPods[i].supplierData.name">
                                </app-labeled-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    <!-- Supplier VAT ID -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">9.2</p>
                                <p>{{ 'invoice.labels.vat_id' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'vat_id_' + i" [inputType]="'text'"
                                    autoMarginTop="mt-0" [(inputValue)]="editedPods[i].supplierData.vat_id">
                                </app-labeled-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Supplier Contact Name -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">9.3</p>
                                <p>{{ 'invoice.labels.contact_name' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'contact_name_' + i"
                                    autoMarginTop="mt-0" [inputType]="'text'"
                                    [(inputValue)]="editedPods[i].supplierData.contact_name">
                                </app-labeled-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Supplier Contact Number -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">9.4</p>
                                <p>{{ 'invoice.labels.contact_number' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'contact_number_' + i"
                                    autoMarginTop="mt-0" [inputType]="'text'"
                                    [(inputValue)]="editedPods[i].supplierData.contact_number">
                                </app-labeled-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Supplier Email -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">9.5</p>
                                <p>{{ 'invoice.labels.email' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'email_' + i" [inputType]="'text'"
                                    autoMarginTop="mt-0" [(inputValue)]="editedPods[i].supplierData.email">
                                </app-labeled-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Supplier Start of Supply -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">6.6</p>
                                <p>{{ 'shared.labels.gas.start_of_supply' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-date-input inputId="'supplier_start_of_supply_' + i"
                                    placeholder="{{ 'shared.placeholders.gas.start_of_supply' | transloco }}"
                                    [(dateValue)]="editedPods[i].supplierData.start_of_supply" [errorMessage]="null"
                                    [isDisabled]="!isEditingInvoiceData" [showOnlyValueWhenDisabled]="true"
                                    autoMarginTop="mt-0" dateFormat="dd/mm/yy" boxHeight="h-[40px]">
                                </app-custom-date-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Supplier End of Supply -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">6.7</p>
                                <p>{{ 'shared.labels.gas.end_of_supply' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-date-input inputId="'supplier_end_of_supply_' + i"
                                    placeholder="{{ 'shared.placeholders.gas.end_of_supply' | transloco }}"
                                    [(dateValue)]="editedPods[i].supplierData.end_of_supply" [errorMessage]="null"
                                    [isDisabled]="!isEditingInvoiceData" [showOnlyValueWhenDisabled]="true"
                                    autoMarginTop="mt-0" dateFormat="dd/mm/yy" boxHeight="h-[40px]">
                                </app-custom-date-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>

    </app-drop-down-section>

    <!----------------------------------------------------------------------------->
    <!-- Admin Notes -->
    <app-drop-down-section title="{{ 'invoice.admin_notes' | transloco }}"
        titleIcon="assets/icons/admin/note-black.svg">
        <!-- Actions-->
        <app-edit-cancel-button header-actions [isEditing]="isEditingInvoiceData" [isSaving]="savingInvoice"
            (edit)="editInvoiceData()" (cancel)="cancelEditInvoiceData()"
            (save)="saveEditInvoiceData()"></app-edit-cancel-button>

        <div class="w-full self-center p-4">
            <app-textarea-input labelText="{{ 'invoice.labels.admin_notes' | transloco }}" inputId="adminNotes"
                [(textValue)]="adminNotesInput" [errorMessage]="adminNotesInputError"
                placeholder="{{ 'invoice.placeholders.admin_notes' | transloco }}"
                boxHeight="min-h-[100px] max-h-[200px]" [isDisabled]="!isEditingInvoiceData">
            </app-textarea-input>
        </div>
    </app-drop-down-section>

    <!----------------------------------------------------------------------------->
    <!-- File Details -->
    <app-drop-down-section title="{{ 'admin.check_file_details' | transloco }}"
        titleIcon="assets/icons/admin/file-question-black.svg" (openedChange)="onFileSummaryOpen($event)">

        <div class="flex flex-col gap-2 w-full p-4">
            <p class="font-semibold text-md">{{ 'admin.file_id' | transloco }}: <span
                    class="font-normal">{{invoice?.file?.id || ''}}</span></p>
        </div>

        <div class="card w-full p-4 flex flex-col gap-2">
            <!-- JSON Generator -->
            <p class="font-bold mobile:text-sm">{{ 'admin.json_generator' | transloco }}
            </p>

            <div class="flex gap-2 flex-wrap">
                <div class="h-[50px] min-w-[150px] max-w-[300px]">
                    <app-custom-button buttonText="{{ 'admin.copy' | transloco }}" (buttonClick)="copyJson()"
                        backgroundColor="bg-purple-600" textColor="text-white" borderColor="border:bg-purple-600"
                        hoverBorderColor="border:bg-purple-700" hoverBackgroundColor="hover:bg-purple-700"
                        leadingIcon="assets/icons/copy-white.svg"></app-custom-button>
                </div>

                <div class="h-[50px] min-w-[150px] max-w-[300px]">
                    <app-custom-button buttonText="{{ 'shared.download' | transloco }}" (buttonClick)="downloadJson()"
                        backgroundColor="bg-purple-600" textColor="text-white" borderColor="border:bg-purple-600"
                        hoverBorderColor="border:bg-purple-700" hoverBackgroundColor="hover:bg-purple-700"
                        leadingIcon="assets/icons/download-white.svg">
                    </app-custom-button>
                </div>
            </div>

            @if(loadingFileSummary)
            {
            <!-- Shimmer -->
            <div class="skeleton h-12 w-full"></div>
            <div class="skeleton h-12 w-full"></div>
            <div class="skeleton h-12 w-full"></div>
            <div class="skeleton h-12 w-full"></div>
            }
            @else {
            <app-file-details-view [fileDetailsResponse]="fileDetailsResponse" [toast]="toast"></app-file-details-view>
            }
        </div>
    </app-drop-down-section>
</div>